export const environment = {
  production: false,
  apiContext: 'ems-api',
  appContext: '',
  devOptions: {
    // showCodingErrors: true,
    // showDevLogins: false,
    showLogs: true,
  },
  bootstrapUrl: 'public/system/bootstrap',
  displayVersion: true,
};
